module.exports = __webpack_public_path__ + "img/keyboard_r1.c03527f8.png";